import React from "react";

function heroElement(tag, className) {
  var HeroElement = React.forwardRef(function HeroElement(props, ref) {
    var forwardedProps = Object.assign({}, props);
    delete forwardedProps.$focused;
    delete forwardedProps.$width;
    var stateClass = props.$focused ? " is-focused" : "";
    forwardedProps.className = className + stateClass + (props.className ? " " + props.className : "");
    forwardedProps.ref = ref;
    return React.createElement(tag, forwardedProps);
  });

  HeroElement.displayName = "HeroElement";
  return HeroElement;
}

export var HeroContainer = heroElement("div", "legacy-detail-hero");

export function HeroBackground(props) {
  var style = Object.assign(
    {
      "--hero-image": props.$image ? "url(" + props.$image + ")" : "none",
      "--hero-lqip": props.$lqipImage ? "url(" + props.$lqipImage + ")" : "none",
    },
    props.style || {}
  );
  return <div {...props} className={"legacy-detail-hero-bg" + (props.className ? " " + props.className : "")} style={style} />;
}

export var VerticalOverlay = heroElement("div", "legacy-detail-hero-vertical-overlay");
export var HorizontalOverlay = heroElement("div", "legacy-detail-hero-horizontal-overlay");
export var ContentWrapper = heroElement("div", "legacy-detail-hero-content-wrapper");
export var ContentInner = heroElement("div", "legacy-detail-hero-content-inner");
export var ContentCell = heroElement("div", "legacy-detail-hero-content-cell");
export var TitleText = heroElement("h1", "legacy-detail-hero-title");
export var SubtitleText = heroElement("h2", "legacy-detail-hero-subtitle");
export var MetadataRow = heroElement("div", "legacy-detail-hero-metadata-row");
export var MetadataItem = heroElement("span", "legacy-detail-hero-metadata-item");
export var DurationWrapper = heroElement("span", "legacy-detail-hero-duration");
export var ClockIcon = heroElement("span", "legacy-detail-hero-clock");
export var AgeBadgeWrapper = heroElement("span", "legacy-detail-hero-age");
export var RatingRow = heroElement("div", "legacy-detail-hero-rating-row");
export var RatingItem = heroElement("span", "legacy-detail-hero-rating-item");
export var ImdbLogo = heroElement("img", "legacy-detail-hero-imdb");
export var LikeIcon = heroElement("img", "legacy-detail-hero-like");
export var RatingText = heroElement("span", "legacy-detail-hero-rating-text");
export var DescriptionText = heroElement("p", "legacy-detail-hero-description");
export var GenreChipsContainer = heroElement("div", "legacy-detail-hero-genres");
export var ActionButtonsRow = heroElement("div", "legacy-detail-hero-actions");
export var VideoLogoContainer = heroElement("div", "legacy-detail-hero-logo-container");
export var VideoLogo = heroElement("img", "legacy-detail-hero-logo");
export var TurkishBadge = heroElement("img", "legacy-detail-hero-turkish");
export var IconActionsContainer = heroElement("div", "legacy-detail-hero-icon-actions");

export var GenreChip = React.forwardRef(function GenreChip(props, ref) {
  var forwardedProps = Object.assign({}, props);
  delete forwardedProps.$focused;
  forwardedProps.className =
    "legacy-detail-hero-genre-chip" +
    (props.$focused ? " is-focused" : "") +
    (props.className ? " " + props.className : "");
  forwardedProps.ref = ref;
  return <button {...forwardedProps} />;
});
GenreChip.displayName = "GenreChip";

export function ButtonSpacer(props) {
  return (
    <span
      {...props}
      className={"legacy-detail-hero-button-spacer" + (props.className ? " " + props.className : "")}
      style={Object.assign({ width: props.$width || "10px" }, props.style || {})}
    />
  );
}
